import React from 'react';
import { Checkbox, Pane, SearchInput, Strong, Text } from 'evergreen-ui';

function CheckBoxDefault({ checkedValue, label, value, index, onToggle, disabled }) {
  const toggle = (e) => {
    const { checked } = e.target;
    onToggle(checked, index);
  };

  return (
    <Checkbox
      margin={0}
      label={label}
      value={value}
      checked={checkedValue}
      disabled={disabled}
      onChange={toggle}
    />
  );
}
const CheckBox = React.memo(CheckBoxDefault);
CheckBox.displayName = 'CheckBox';

function CheckboxListDefault({
  values = [],
  checkedValues = [],
  setCheckedValues,
  labelProp,
  checkProp,
  maxChecked,
  minChecked,
  LabelElement,
}) {
  const [searchText, setSearchText] = React.useState('');

  const filteredValues = React.useMemo(() => values.filter((value) => {
    if (searchText === '') return true;
    if (typeof labelProp === 'string') {
      return value[labelProp].toUpperCase().includes(searchText.toUpperCase());
    }
    return labelProp.some((prop) => value[prop]?.toUpperCase().includes(searchText.toUpperCase()));
  }), [labelProp, searchText, values]);

  const filteredByChecked = React.useMemo(() => filteredValues.filter(
    (value) => !checkedValues.some((val) => val[checkProp] === value[checkProp]),
  ), [checkProp, checkedValues, filteredValues]);

  const onToggle = (checked, index) => {
    setCheckedValues((cur) => {
      if (checked) {
        return [...cur, values[index]];
      }
      const tmp = JSON.parse(JSON.stringify(cur));
      tmp.splice(index, 1);
      return tmp;
    });
  };

  const onSelectAll = (e) => {
    const { checked } = e.target;
    if (checked) {
      setCheckedValues(values);
    } else {
      setCheckedValues(values.slice(0, minChecked || null));
    }
  };

  const isDisabled = (value) => {
    const founded = checkedValues.find((val) => val[checkProp] === value[checkProp]);
    if (checkedValues.length === minChecked && founded) return true;
    return checkedValues.length === maxChecked && !founded;
  };

  const getOriginalIndex = (value) => values.findIndex((val) => val[checkProp] === value[checkProp]);

  return (
    <Pane display="grid" gridTemplateRows="max-content 1fr" rowGap=".5rem" overflow="hidden">
      <Pane display="grid" gridTemplateColumns="1fr max-content" columnGap=".5rem" alignItems="center">
        <SearchInput width="100%" value={searchText} onChange={(e) => setSearchText(e.target.value)} />
        <Checkbox
          disabled={!!maxChecked}
          checked={checkedValues.length === values.length}
          onChange={onSelectAll}
          label="Выбрать/убрать все"
        />
      </Pane>
      <Pane display="grid" gridTemplateColumns="1fr 1fr" columnGap=".5rem" overflow="hidden">
        <Pane display="grid" gridTemplateRows="max-content 1fr" rowGap=".5rem" overflow="auto">
          <Strong>Доступные значения</Strong>
          <Pane display="grid" gridAutoFlow="row" gridAutoRows="max-content" rowGap=".5rem" height={180} overflowY="scroll">
            {
              filteredByChecked.length > 0
                ? React.Children.toArray(filteredByChecked.map((value) => (
                  <CheckBox
                    label={LabelElement ? <LabelElement value={value} /> : value[labelProp]}
                    disabled={isDisabled(value)}
                    onToggle={onToggle}
                    index={getOriginalIndex(value)}
                  />
                )))
                : <Text>Нет значений</Text>
            }
          </Pane>
        </Pane>
        <Pane display="grid" gridTemplateRows="max-content 1fr" rowGap=".5rem" overflow="auto">
          <Strong>Выбранные значения</Strong>
          <Pane display="grid" gridAutoFlow="row" gridAutoRows="max-content" rowGap=".5rem" height={180} overflowY="scroll">
            {
              checkedValues.length > 0
                ? React.Children.toArray(checkedValues.map((value, index) => (
                  <CheckBox
                    label={LabelElement ? <LabelElement value={value} /> : value[labelProp]}
                    disabled={isDisabled(value)}
                    onToggle={onToggle}
                    index={index}
                    checkedValue
                  />
                )))
                : <Text>Нет значений</Text>
            }
          </Pane>
        </Pane>
      </Pane>
    </Pane>
  );
}

export const CheckboxList = React.memo(CheckboxListDefault);
CheckboxList.displayName = 'CheckboxList';
